import React, { Component } from 'react'
import { Link } from 'react-router-dom'

const commentListStyles = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
}

const commentCardStyles = {
  maxWidth: "30%",
  minWidth: "150px",
  flex: "1",
  margin: "5px",
}

class CommentList extends Component {
  render() {
    const { comments } = this.props
    const commentIds = Object.keys(comments)

    return (
      <div>
        <h1 style={{marginBottom: "0.5em"}}>Comments</h1>

        <div style={commentListStyles}>
          {commentIds.map((id) => {
            const comment = comments[id]
            return (
              <div key={id} style={commentCardStyles} className="pt-card pt-elevation-0 pt-interactive">
                <h5><Link to={`/songs/${id}`}>{comment.comment}</Link></h5>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default CommentList


// WEBPACK FOOTER //
// ./src/components/Notes/CommentList.jsx